import { cn } from '@/lib/utils'

interface GridFieldProps {
    /** Cell size in pixels. */
    size?: number
    className?: string
}

/**
 * The signature: a designer's artboard grid, drawn as real hairlines.
 * Purely decorative, hidden from assistive tech, and never the only thing
 * carrying meaning.
 */
export const GridField = ({ size = 56, className }: GridFieldProps) => {
    return (
        <div aria-hidden className={cn('pointer-events-none absolute inset-0 overflow-hidden', className)}>
            <svg className='h-full w-full text-line' width='100%' height='100%'>
                <defs>
                    <pattern id={`artboard-${size}`} width={size} height={size} patternUnits='userSpaceOnUse'>
                        <path
                            d={`M ${size} 0 L 0 0 0 ${size}`}
                            fill='none'
                            stroke='currentColor'
                            strokeWidth='1'
                        />
                    </pattern>
                </defs>
                <rect width='100%' height='100%' fill={`url(#artboard-${size})`} />
            </svg>
        </div>
    )
}

interface CropMarksProps {
    className?: string
}

/**
 * Registration marks at the four corners of a frame. Print-shop language,
 * borrowed for the one place a logo is presented.
 */
export const CropMarks = ({ className }: CropMarksProps) => {
    return (
        <div aria-hidden className={cn('pointer-events-none absolute inset-0', className)}>
            <span className='absolute left-0 top-0 h-4 w-px bg-line-strong' />
            <span className='absolute left-0 top-0 h-px w-4 bg-line-strong' />
            <span className='absolute right-0 top-0 h-4 w-px bg-line-strong' />
            <span className='absolute right-0 top-0 h-px w-4 bg-line-strong' />
            <span className='absolute bottom-0 left-0 h-4 w-px bg-line-strong' />
            <span className='absolute bottom-0 left-0 h-px w-4 bg-line-strong' />
            <span className='absolute bottom-0 right-0 h-4 w-px bg-line-strong' />
            <span className='absolute bottom-0 right-0 h-px w-4 bg-line-strong' />
        </div>
    )
}
